module.exports = __webpack_public_path__ + "img/屈臣氏.038b7dd6.png";